(function () {
    'use strict';

    angular
        .module('franchisee-portal.filters')
        .filter('minutesToHour', formatMinutesToHour)

    function formatMinutesToHour() {
        return value => {
            let hour = Math.floor(value / 60);
            let minutes = value % 60;

            hour = hour < 10 ? `0${hour}` : hour;
            minutes = minutes < 10 ? `0${minutes}` : minutes;

            let finalTime = `${hour}h`;

            if (minutes != '00')
                finalTime = `${finalTime} ${minutes}min`

            return finalTime;
        }
    }
}());